module.exports = __webpack_public_path__ + "static/media/networkobjects.090f8691.svg";